import React from "react";
import { Routes, Route, HashRouter } from "react-router-dom";


import Home from "./Home";
import About from "./About";
import Services from "./Services";
import Projects from "./Projects";
import Contact from "./Contact";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ProjectDetails from "./ProjectDetails";
import WhatsAppButton from "./Whatsappbutton";
import Admin from "./Admin";
import LayoutMap from "./LayoutMap";
import LocationMap from "./LocationMap";
import Gallery from "./Gallery";





function App() {
  return (
    <HashRouter>

      <Navbar/>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/projects/:id" element = {<ProjectDetails/>}/>
         <Route path="/admin" element={<Admin />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/layout/:id" element ={<LayoutMap/>}/>
        <Route path="/location-map/:id" element={<LocationMap/>}/>
        <Route path="/gallery" element ={<Gallery/>}/>
           
      </Routes>

      <Footer />
      <WhatsAppButton/>

    </HashRouter>
  );
}

export default App;
